module.exports = __webpack_public_path__ + "img/strawberry.8568668b.webp";